__turbopack_context__.v({
  "backIcon": "BackLink-module-scss-module__Li8-aa__backIcon",
  "backLink": "BackLink-module-scss-module__Li8-aa__backLink",
  "backLinkGrey": "BackLink-module-scss-module__Li8-aa__backLinkGrey",
});
